// Alpine integration entrypoint. Runs before Alpine.start().
// Use to register plugins, expose globals, and any pre-start setup.
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Chart from 'chart.js/auto';
import { valueFilterState, yearSortState } from '../util/lightRouteFilters.js';

/**
 * @param {import('alpinejs').Alpine} Alpine
 */
export default (Alpine) => {
  try {
  Alpine.plugin(collapse);
  Alpine.plugin(intersect);
  } catch (e) {
    console.warn('[alpine-entry] collapse plugin registration failed', e);
  }

  // Expose helpers + Chart to window for legacy usage patterns
  // @ts-ignore
  window.valueFilterState = valueFilterState;
  // @ts-ignore
  window.yearSortState = yearSortState;
  // @ts-ignore
  window.Chart = Chart;

  // Lightweight marker so layout CSS can uncloak once Alpine starts
  document.addEventListener('alpine:init', () => {
    document.documentElement.classList.add('alpine-started');
  // For existing fallback detection logic
  try { window.__ALPINE_STARTED = true; } catch(_) {}
    console.log('[alpine-entry] Alpine init (v' + Alpine.version + ')');
  }, { once: true });
};
